import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import Cookies from 'js-cookie'
import { createCookieMiddleware } from 'redux-cookie'
import rootReducer from '../reducers'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = preloadedState => createStore(rootReducer, preloadedState, composeEnhancers(
  applyMiddleware(thunk),
  applyMiddleware(createCookieMiddleware(Cookies))
))

export default configureStore
